import { render, staticRenderFns } from "./DeletionIndicator.vue?vue&type=template&id=2e1d4182&scoped=true&lang=html&"
import script from "./DeletionIndicator.vue?vue&type=script&lang=js&"
export * from "./DeletionIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DeletionIndicator.vue?vue&type=style&index=0&id=2e1d4182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d4182",
  null
  
)

export default component.exports